var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgXtwiter = _a => {
  var _b, _c, _d;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("g", {
    id: "Icon svg",
    clipPath: "url(#clip0_4144_4)"
  }, React.createElement("path", {
    id: "Vector",
    d: "M3.66667 0C1.64773 0 0 1.64773 0 3.66667V18.3333C0 20.3523 1.64773 22 3.66667 22H18.3333C20.3523 22 22 20.3523 22 18.3333V3.66667C22 1.64773 20.3523 0 18.3333 0H3.66667ZM3.66667 1.04762H18.3333C19.7862 1.04762 20.9524 2.21379 20.9524 3.66667V18.3333C20.9524 19.7862 19.7862 20.9524 18.3333 20.9524H3.66667C2.21379 20.9524 1.04762 19.7862 1.04762 18.3333V3.66667C1.04762 2.21379 2.21379 1.04762 3.66667 1.04762ZM4.7593 4.71429L9.59022 11.578L4.71429 17.2857H6.02381L10.1815 12.418L13.6068 17.2857H17.7645L12.4609 9.74981L16.7619 4.71429H15.4524L11.8696 8.90988L8.91704 4.71429H4.7593ZM6.76451 5.76191H8.3697L15.7593 16.2381H14.1541L6.76451 5.76191Z",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_4144_4"
  }, React.createElement("rect", {
    width: 22,
    height: 22,
    fill: (_d = props.color) !== null && _d !== void 0 ? _d : 'currentColor'
  }))));
};
export default SvgXtwiter;